// opervex-frontend/src/pages/Reports/GoodsMovement.js

import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import DynamicReport from "../../components/DynamicReport";
import useOpervex from "../../hooks/useOpervex";

const GoodsMovement = () => {
  const [schema, setSchema] = useState(null);
  const OpervexAPI = useOpervex();

  useEffect(() => {
    const loadSchema = async () => {
      const result = await OpervexAPI.Report.GoodsMovement.schema();
      setSchema(result);
    };

    loadSchema();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!schema) {
    return (
      <Container fluid className="text-center mt-5">
        <span>Carregando relatório...</span>
      </Container>
    );
  }

  return (
    <Container fluid>
      <h1 className="fw-light text-center">Relatório de Movimentação</h1>

      <DynamicReport
        reportName={"reportGoodsMovement"}
        urlData={"/Report/GoodsMovement"}
        schema={schema}
        links={[{ key: "id", link: "/MaterialManagement/GoodsMovement/:id", newPage: true }]}
      />
    </Container>
  );
};

export default GoodsMovement;
